import { render, staticRenderFns } from "./ActionPallet.vue?vue&type=template&id=e74608e0&"
import script from "./ActionPallet.vue?vue&type=script&lang=js&"
export * from "./ActionPallet.vue?vue&type=script&lang=js&"
import style0 from "./ActionPallet.vue?vue&type=style&index=0&id=e74608e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports